// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { HomepageExperienceCookie } from '../cookies';

angular
  .module('landingPage')
  .directive(
    'homepageModal',
    ($document, StartPageService, startPageTrackingService) => ({
      restrict: 'A',

      link(scope, element, attrs) {
        const init = () => initCyoaCookie();
        const cookie = HomepageExperienceCookie.find();

        var initCyoaCookie = function (value = 'homepage') {
          if (
            !cookie.value ||
            (cookie.value !== 'homepage' && cookie.value !== 'creative')
          ) {
            cookie.value = value;
          }
        };

        return init();
      },
    })
  );
